const value = Object.freeze({
  Summary: 0,
  Detail: 1,
});
export default value;
